(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;

    const nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    const wrap = btn.closest('[data-load-more-wrap]');
    const updateCount = () => {
      if (!wrap) return;
      const total = Number(wrap.dataset.total) || 0;
      const shown = document.querySelectorAll('#ResultsList li.product-grid__item').length;
      const shownEl = wrap.querySelector('[data-load-more-shown]');
      const bar = wrap.querySelector('[data-load-more-bar]');
      if (shownEl) shownEl.textContent = String(Math.min(shown, total || shown));
      if (bar && total) bar.style.width = `${Math.min(100, Math.round((shown / total) * 100))}%`;
    };

    try {
      const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('li.product-grid__item');
      const currentList = document.querySelector('#ResultsList li.product-grid__item')?.parentElement;

      if (!currentList || !newItems.length) {
        btn.remove();
        return;
      }

      newItems.forEach((item) => currentList.appendChild(item));
      updateCount();

      const newBtn = doc.querySelector('[data-load-more]');
      const newNextUrl = newBtn?.getAttribute('data-next-url') || '';

      if (!newNextUrl) {
        btn.remove();
      } else {
        btn.setAttribute('data-next-url', newNextUrl);
        btn.disabled = false;
      }
    } catch (err) {
      console.error(err);
      btn.disabled = false;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
